import React from 'react'
import classNames from 'classnames'

const HorizontalSpacer: React.FC<{ className?: string }> = ({
  className,
  children,
}) => {
  return <div className={classNames(className, 'px-2 md:px-0')}>{children}</div>
}

export { HorizontalSpacer }
